import { render, staticRenderFns } from "./PostsPage.vue?vue&type=template&id=4441576c&scoped=true&"
import script from "./PostsPage.vue?vue&type=script&lang=js&"
export * from "./PostsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4441576c",
  null
  
)

export default component.exports